<template>
<div>
	<ul class="sub-nav">
		<li v-on:click="showTab('email')">
			<i class="material-icons md-18">email</i> EMAIL
			<span class="sub-nav-value">
				{{agent.email}}
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		<li v-on:click="showTab('password')">
			<i class="material-icons md-18">vpn_key</i> PASSWORD
			<span class="sub-nav-value">
				Change
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		<li v-if="planCurrent" v-on:click="showTab('plan')">
			<i class="material-icons md-18">verified_user</i> PLAN
			<span class="sub-nav-value">
				{{planName}}
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		<!--li v-on:click="showTab('team')">
			<i class="material-icons md-18">group</i> TEAM (1)
			<span class="sub-nav-value">
				1 member
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li-->
		<li v-on:click="showTab('billing')">
			<i class="material-icons md-18">credit_card</i> BILLING
			<span class="sub-nav-value">
				{{this.billingCards}}
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
	</ul>
	<div class="overflow-hidden">
		<button v-on:click="logout" class="btn btn-light btn-sm float-right">Logout</button>
	</div>
</div>
</template>
<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

export default {
	name: 'agent-overview',
	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
	},
	props: {
		agent:{
			type:Object
		},
		planCurrent:{
			type:Object
		},
	},
	computed:{
		cards: function(){
			if (!this.$store.state.stripe || !this.$store.state.stripe.customer || !this.$store.state.stripe.customer.sources)
				return null;
			return this.$store.state.stripe.customer.sources.data;
		},
		billingCards:function(){
			if (!this.cards || this.cards.length < 1) return 'Add card';
			return `Cards (${this.cards.length})`;
		},
		planName:function(){
			if (!this.planCurrent) return 'No active subscription';
			if (this.planCurrent.plan.id === 'plan_3') return 'Annual Subscription';
			if (this.planCurrent.plan.id === 'plan_2') return 'Day Pass';
			if (this.planCurrent.plan.id === 'plan_1') return 'Studio Subscription';
		},
	},
	methods: {
		logout: function(){
			this.$store.dispatch('AGENT_LOGOUT');
			this.$router.push({
				name:'auth-tab',
				params:{
					tab:'login'
				}
			});
		},
		showTab:function(tab){
			this.$router.push({
				name:'agent-tab',
				params:{
					tab:tab
				}
			});
		},
	},
}

</script>

<style>
	.btn-more{
		position:relative;
		padding:.15rem .25rem;
    	font-size:.75rem;
    	margin-left:.5rem;
	}
	.sub-nav{
		margin:0 0 1rem 0;
		padding:0;
	}
	.sub-nav li{
		border-bottom:1px solid #EFEFEF;
		line-height:2.5rem;
		list-style-type:none;
		font-size:0.8rem;
		opacity:1;
		cursor:pointer;
		position:relative;
		padding-right:18px;
		overflow:hidden;
	}
	.sub-nav li.inactive{
		color:#9E9E9E;
		cursor:default;
	}
	.sub-nav li:hover{
		color:#0687D1;
	}
	.sub-nav li.inactive:hover{
		color:#9E9E9E;
	}
	.sub-nav li i{
		position:relative;
		top:-1px;
		margin-right:4px;
	}
	.sub-nav i.arrow-more{
		position:absolute;
		top:10.5px;
		right:-4px;
		margin-right:0;
	}
	.sub-nav li.inactive .arrow-more{
		display:none;
	}
	.sub-nav-value{
		float:right;
	}
</style>


// WEBPACK FOOTER //
// src/components/agent/agent-overview.vue